<template>
    <response-dialog
        :model.sync="model"
        :message="message"
        :type="type"
        @close="close()"
    />
</template>

<script>
import ResponseDialog from './ResponseDialog.vue';
export default {
    name: "SimpleMessageDialog",
    components: { ResponseDialog },
    data: () => ({
        message: '',
        type: '',
        model: false
    }),
    methods: {
        open (dialogText, dialogType = 'info') {
            this.message = dialogText;
            this.type = dialogType;
            this.model = true;
        },
        close () {
            this.model = false;
            this.clear();
        },
        clear () {
            this.message = '';
            this.type = '';
        }
    },
}
</script>
